import {
  Design,
  DesignItemType,
  DesignModule,
  DesignModuleNode,
  DesignObject,
  NodeTypeName
} from '../../../types';

function setSensitive(
  item: {
    sensitive?: boolean;
    sensitiveData?: boolean;
  },
  value: boolean
): void {
  if ('sensitiveData' in item) {
    item.sensitiveData = value;
  }
  if ('sensitive' in item) {
    item.sensitive = value;
  }
}

function setSensitiveOnItem(
  item: DesignModule | DesignModuleNode | DesignObject | undefined,
  value: boolean
): void {
  if (!item) {
    return;
  }

  if ('localVariables' in item) {
    (item.localVariables ?? []).forEach((lv) => {
      setSensitive(lv.props.config, value);
    });
  }

  if (
    'sensitiveOverrides' in item.props.config
    && item.props.config.sensitiveOverrides
  ) {
    item.props.config.sensitiveOverrides.enabled = value;
  }

  if (item.props.nodeTypeName === NodeTypeName.input) {
    setSensitive(item.props.config, value);
  }

  if (item.props.config.inputs) {
    item.props.config.inputs.forEach((inp) => {
      setSensitive(inp, value);
    });
  }

  if (item.props.config.outputs) {
    item.props.config.outputs.forEach((oup) => {
      setSensitive(oup, value);
    });
  }
}

/** Add branching event to the design. */
export function resetCommonModuleLocalVariablesNotSensitive(
  itemId: string,
  serialized: Design,
  type: DesignItemType = DesignItemType.module
): void {
  switch (type) {
    case DesignItemType.module: {
      const moduleMatch = serialized.components.modules.find((mod) => {
        return mod.id === itemId;
      });
      setSensitiveOnItem(moduleMatch, false);

      moduleMatch?.versions[1].flow.nodes.forEach((node) => {
        setSensitiveOnItem(node, false);

        if (node.props.parentComponentID) {
          resetCommonModuleLocalVariablesNotSensitive(
            node.props.parentComponentID,
            serialized,
            node.type
          );
        }
      });
      break;
    }
    case DesignItemType.object: {
      const objectMatch = serialized.components.objects.find((obj) => {
        return obj.id === itemId;
      });
      setSensitiveOnItem(objectMatch, false);
      break;
    }
  }
}
